import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EvSearchHistoryApi } from "../../apiclient/api/EvSearchHistoryApi";
var searchHistoryApi = new EvSearchHistoryApi();
export var fetchSearchHistory = createAsyncThunk("searchhistory/get", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var response, ids, count, entities;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return searchHistoryApi.getSearchHistory();
        case 2:
          response = _context.sent;
          ids = [];
          count = response.length;
          entities = {};
          response.forEach(function (element) {
            ids.push(element.searchId);
            entities[element.searchId] = element;
          });
          return _context.abrupt("return", {
            count: count,
            ids: ids,
            entities: entities
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
var initialState = {
  status: "init",
  count: 0,
  entities: {},
  ids: []
};
var searchHistorySlice = createSlice({
  name: "searchhistory",
  initialState: initialState,
  reducers: {
    // omit reducer cases
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchSearchHistory.pending, function (state) {
      state.status = "pending";
    }).addCase(fetchSearchHistory.fulfilled, function (state, _ref2) {
      var payload = _ref2.payload;
      state.status = "done";
      state.count = payload.count;
      state.ids = payload.ids;
      state.entities = payload.entities;
    }).addCase(fetchSearchHistory.rejected, function (state) {
      state.status = "error";
    });
  }
});
export var selectSearchHistoryState = function selectSearchHistoryState(state) {
  return state.searchhistory;
};
export default searchHistorySlice.reducer;